import { productsApiClient } from '../httpClient'

export const getDentalProducts = async (skip: number, limit: number) =>
    await productsApiClient.get(`/api/v1/products/dental?skip=${skip}&limit=${limit}`)

export const getDentalPlan = async (planId: string) =>
    await productsApiClient.get(`/api/v1/products/dental/${planId}`)
